import { toDate as o } from "./toDate.js";
function a(e) {
  const t = o(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
export {
  a as default,
  a as startOfMonth
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfMonth.js
// module id = 434
// module chunks = 41